module.exports = __webpack_public_path__ + "static/img/book20.821e261.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book20.jpg
// module id = fiBw
// module chunks = 1